import { Button, Modal } from 'react-daisyui';

// Own components
import { useTeamContext } from '../../../Team.context.ts';
import { useTranslation } from 'react-i18next';

export default function EditUserConfirm() {
  const {
    showConfirmEditUserModal,
    setShowConfirmEditUserModal,
    editUserFormik,
    toggleEditUserModal,
    setUserToEdit,
  } = useTeamContext();
  const { t } = useTranslation('settings/team');

  return (
    <Modal
      open={showConfirmEditUserModal}
      onClose={() => setShowConfirmEditUserModal(false)}
      className="EditUserModal"
      backdrop={true}
      responsive={true}
    >
      <Modal.Header className="TeamSection__Modal__Header">
        <div className="flex flex-col items-center w-full">
          <h1 className="text-lg text-center font-bold">
            {t('page.modalConfirm.title')}
          </h1>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col w-full">
          <p className="mb-2 text-md">{t('page.modalConfirm.text')}</p>
          <p className="my-2 font-bold text-md">
            {t('page.modalConfirm.text2')}
          </p>
          <p className="my-2 text-error text-md">
            {t('page.modalConfirm.text3')}
          </p>
          <div className="flex flex-row items-center w-full justify-end gap-2 mt-4">
            <Button
              color="neutral"
              size="sm"
              onClick={() => {
                setShowConfirmEditUserModal(false);
                setUserToEdit(null);
                toggleEditUserModal(false);
              }}
            >
              {t('page.modalConfirm.btnCancel')}
            </Button>
            <Button
              color="error"
              size="sm"
              onClick={() => {
                setShowConfirmEditUserModal(false);
                editUserFormik?.handleSubmit();
              }}
            >
              {t('page.modalConfirm.btnConfirm')}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
